import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Stack,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { 
  Phone, 
  WhatsApp, 
  Home as HomeIcon,
  CleaningServices as CleaningServicesIcon,
  Assignment as AssignmentIcon,
  Work as WorkIcon,
  Login as LoginIcon 
} from "@mui/icons-material";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: "Home", path: "/", icon: HomeIcon },
    { text: "Services", path: "/services", icon: CleaningServicesIcon },
    { text: "Checklist", path: "/checklist", icon: AssignmentIcon },
    { text: "Careers", path: "/careers", icon: WorkIcon },
    // { text: "Payments", path: "" },
    { text: "Log In", path: "/log-in", icon: LoginIcon },
  ];

  return (
    <AppBar position="static" color="primary" sx={{ width: "100%" }}>
      <Container maxWidth="xl" sx={{ px: 0 }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Link to="/" style={{ display: "inline-block" }}>
              <img src="/favicon-white.png" alt="Logo" style={{ width: 40, height: 40, }} />
            </Link>
            <Typography variant={isMobile ? "h6" : "h4"} fontWeight="bold"
              sx={{
                transform: 'rotate(-20deg)',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'rotate(20deg)',
                },
              }}
            >BnB</Typography>
            <Typography variant={isMobile ? "subtitle2" : "h6"} fontWeight="bold"
              sx={{
                transform: 'rotate(-20deg)',
                // display: 'inline-block',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'rotate(20deg)',
                },
              }}
            >Cleaning</Typography>
            {/* <Typography variant={isMobile ? "subtitle2" : "h6"} fontWeight="bold"
              sx={{
                // transform: 'rotate(-20deg)',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'rotate(-20deg)',
                },
              }}
            >Team</Typography> */}
          </Box>

          {isMobile ? (
            <>
              {/* Mobile Menu Icon */}
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={handleDrawerToggle}
              >
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mr: "1px" }}>MENU</Typography>
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                PaperProps={{
                  sx: {
                    width: 280,
                    bgcolor: "background.paper",
                    pt: 2,
                  }
                }}
              >
                <Box sx={{ width: "100%" }} role="presentation">
                  <List sx={{ px: 1 }}>
                    {menuItems.map(({ text, path, icon: Icon }) => {
                      const isActive = location.pathname === path;
                      return (
                        <ListItem key={text} disablePadding sx={{ mb: 0.5 }}>
                          <ListItemButton
                            component={Link}
                            to={path}
                            onClick={handleDrawerToggle}
                            sx={{
                              borderRadius: 2,
                              py: 1.5,
                              px: 2,
                              bgcolor: isActive ? "rgba(255, 56, 92, 0.12)" : "transparent",
                              color: isActive ? "#FF385C" : "text.primary",
                              "&:hover": {
                                bgcolor: isActive ? "rgba(255, 56, 92, 0.18)" : "rgba(0, 0, 0, 0.04)",
                              },
                              transition: "all 0.2s ease",
                            }}
                          >
                            {Icon && (
                              <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
                                <Icon sx={{ color: isActive ? "#FF385C" : "action.active" }} />
                              </Box>
                            )}
                            <ListItemText 
                              primary={text}
                              primaryTypographyProps={{
                                fontWeight: isActive ? 600 : 400,
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                  </List>
                </Box>
              </Drawer>
            </>
          ) : (
            <Stack direction="row" spacing={2}>
              {menuItems.map(({ text, path }) => {
                const isActive = location.pathname === path;
                return (
                  <Button
                    key={text}
                    color="inherit"
                    component={Link}
                    to={path}
                    sx={{
                      border: isActive ? 2 : 0,
                      borderColor: "#ffffff",
                    }}
                  >
                    {text}
                  </Button>
                );
              })}
            </Stack>
          )}

          {/* Book Now Button Always Visible */}
          <a href="tel:4376884752" style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              color="secondary"
              sx={{
                ml: 2,
                color: '#FF385C',
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Phone fontSize="small" />
                <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 }}>
                  <WhatsApp fontSize="small" />
                  437-688-4752
                </Box>
              </Box>
            </Button>
          </a>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
